module.exports = __webpack_public_path__ + "static/media/3DPPA33.e53b7499.jpg";